import { omitBy, isNil, uniq } from 'lodash-es'
import { useI18n } from 'vue-i18n'

export function useContextFields(document, text, elements, matches) {
  const { t } = useI18n()
  return omitBy({
    [t('result.context.header.document.level')]: document.level,
    [t('result.context.header.document.gender')]: document.gender,
    [t('result.context.header.document.l1')]: document.l1,
    [t('result.context.header.document.english_status')]: document.english_status,
    [t('result.context.header.document.preparation_course')]: document.preparation_course,
    [t('result.context.header.document.text_formality')]: document.text_formality,
    [t('result.context.header.document.text_type')]: document.text_type,
    [t('result.context.header.document.illocutionary_act')]: document.illocutionary_act,
    [t('result.context.header.document.text_topic')]: document.text_topic,
    [t('result.context.header.document.candidate_number')]: document.candidate_number,
  }, v => v === '' || isNil(v))
}
